<template>
  <span :style="{ fontSize: fontSize }">
    {{ displayFigure ? num : '' }}
    <font-awesome-icon
      v-if="num === 0"
      icon="circle"
      class="has-text-black"
    />
    <font-awesome-icon
      v-else-if="num > 0"
      icon="arrow-circle-up"
      class="has-text-success"
    />
    <font-awesome-icon
      v-else
      icon="arrow-circle-down"
      class="has-text-danger"
    />
  </span>
</template>

<script>
export default {

  name: 'TrendArrow',
  props: {
    num: {
      type: Number,
      default: 10
    },
    displayFigure: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: String,
      default: '1em'
    }
  }
}
</script>
